const normalizeTimestamp = (value) => {
  if (!value) {
    return null
  }

  if (typeof value.seconds === 'number') {
    return { seconds: value.seconds }
  }

  if (typeof value.toDate === 'function') {
    return { seconds: Math.floor(value.toDate().getTime() / 1000) }
  }

  return null
}

const normalizeStringArray = (value) => (Array.isArray(value) ? value.filter(Boolean) : [])

export const mapCampaignLinkListItem = (id, data = {}) => ({
  id,
  shortUrl: data.short_url || '',
  shortSlug: data.short_slug || '',
  title: data.title || '',
  channel: data.channel || '',
  format: data.format || '',
  direction: data.direction || '',
  responsible: data.responsible || '',
  responsibleLabel: data.responsible_label || '',
  isActive: data.is_active !== false,
  updatedAt: normalizeTimestamp(data.updated_at),
  createdAt: normalizeTimestamp(data.created_at),
  updatedAtSort: data.updated_at?.seconds || data.created_at?.seconds || 0,
  relatedPromoTitle: data.related_promo_title || '',
  relatedProductName: data.related_product_name || data.related_product_label || '',
  relatedBrandNames: Array.isArray(data.related_brand_names) ? data.related_brand_names : [],
  relatedGlobalCategoryName: data.related_global_category_name || '',
  relatedCategoryPathLabel: data.related_category_path_label || '',
  relatedGlobalCategoryPath: normalizeStringArray(data.related_global_category_path),
})

export default mapCampaignLinkListItem
